module.exports = __webpack_public_path__ + "static/media/10.ec87b28f.png";